import { Component, OnInit } from '@angular/core';
import { SearchFormComponent } from '@dinein-lib/shared';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
})
export class CustomSearchFormComponent extends SearchFormComponent implements OnInit {}
